<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12">
        <exercise-logic-id
          exCollection="challengesSystemExCollection"
          refCollection=""
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedEx="onLoadedEx"
          @modifyEx="onModifyEx"
          @loadedRef="onLoadedRef"
          :doc="doc"
          :shared="false"
          :projectShared="false"
          :pid="true"
          :eid="$route.params.eid"
          :synced="false"
        >
          <template slot-scope="{ saveExercise, doc }">
            <v-row v-if="doc">
              <v-col cols="4">
                <v-card>
                  <v-card-title>
                    Document settings
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="Title"
                      v-model.trim="doc.title"
                      type="text"
                      required
                      :hide-details="false"
                      color="amber"
                    ></v-text-field>

                    <v-select
                      label="Column width"
                      v-model.trim="doc.attrs.cols"
                      :items="['1', '2', '3', '4', '6', '12', 'auto']"
                    />

                    <div class="d-flex flex-wrap">
                      <v-switch
                        v-model="doc.attrs.details"
                        label="Details"
                        color="amber"
                        class="mr-3 ml-3"
                        inset
                      ></v-switch>

                      <v-switch
                        v-model="doc.attrs.tags"
                        label="Tags"
                        color="amber"
                        class="mr-3 ml-3"
                        inset
                      ></v-switch>

                      <v-switch
                        v-model="doc.attrs.edit"
                        label="Edit Categories"
                        color="amber"
                        class="mr-3 ml-3"
                        inset
                      ></v-switch>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="8">
                <v-card>
                  <v-card-title>
                    Document settings
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <template v-if="doc.attrs.edit">
                        <v-col cols="4">
                          <div class="d-flex">
                            <unit-sub-items
                              v-model="doc.local.categories"
                              name="sub"
                            >
                              <v-label
                                ><span class="black--text"
                                  >Categories</span
                                ></v-label
                              >
                              <p class="ma-0">
                                Type below and press <strong>Add</strong>
                              </p>
                            </unit-sub-items>
                          </div>
                        </v-col>

                        <v-col cols="4">
                          <div class="d-flex">
                            <unit-sub-items v-model="doc.local.tags" name="sub">
                              <v-label class="black--text"
                                ><span class="black--text">Tags</span></v-label
                              >
                              <p class="ma-0">
                                Type below and press <strong>Add</strong>
                              </p>
                            </unit-sub-items>
                          </div>
                        </v-col>

                        <v-col cols="4">
                          <div class="d-flex">
                            <unit-sub-items
                              v-model="doc.local.themes"
                              name="sub"
                            >
                              <v-label class="black--text"
                                ><span class="black--text"
                                  >Themes</span
                                ></v-label
                              >
                              <p class="ma-0">
                                Type below and press <strong>Add</strong>
                              </p>
                            </unit-sub-items>
                          </div>
                        </v-col>
                      </template>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step
                  color="amber"
                  :complete="e1 > 1"
                  step="1"
                  @click="e1 = 1"
                  >Challanges</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step
                  color="amber"
                  :complete="e1 > 2"
                  step="1"
                  @click="e1 = 2"
                  >Organise</v-stepper-step
                >
                <v-divider></v-divider>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <!-- Document controls  -->

                  <v-sheet light>
                    <Challenges
                      :items="doc.allItems"
                      :attrs="doc.attrs"
                      :local="doc.local"
                      :key="editKey"
                      @updated="updateItems"
                    />
                  </v-sheet>

                  <!-- Document items  -->

                  <bottom-navigation
                    :save="true"
                    :next="true"
                    :prev="false"
                    :gridView="false"
                    :gridToggle="false"
                    @prev="prevStep"
                    @next="nextStep"
                    @save="saveExercise(true)"
                  >
                  </bottom-navigation
                ></v-stepper-content>
                <v-stepper-content step="2">
                  <ChallengesView
                    :items="doc.allItems"
                    :attrs="doc.attrs"
                    :local="doc.local"
                    :key="editKey"
                    :doc="doc"
                    @updated="updateItems"/>
                  <bottom-navigation
                    :save="true"
                    :next="false"
                    :prev="true"
                    :gridView="false"
                    :gridToggle="false"
                    @prev="prevStep"
                    @next="nextStep"
                    @save="saveExercise(true)"
                  >
                  </bottom-navigation
                ></v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
        </exercise-logic-id>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title
          class="headline"
          v-text="$t('exercise_service.saved.title')"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogicId } from "@/components/exercises";

import { UnitSubItems } from "@/components/units";

import {
  Challenges,
  ChallengesView,
} from "@/views/user/exercises/challenges-system";

export default {
  name: "UserChallengesSystemId",
  data() {
    return {
      e1: 1,
      exercises: null,
      refs: null,
      dialog: false,
      iso: null,
      moveEl: null,
      moveList: null,
      dialogMode: "save",
      allItems: null,
      listName: "",
      test: false,
      revision: 1,
      editKey: 0,
      doc: {
        allItems: [],
        title: "",
        priorityRange: [1, 3],
        attrs: {
          cols: "4",
          edit: true,
          categories: false,
          controls: true,
          details: false,
          tags: false,
        },
        local: {
          categories: [],
          tags: [],
          themes: [],
        },
      },
      listLength: 1,
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogicId,
    UnitSubItems,
    Challenges,
    ChallengesView,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    computedWidth() {
      if (this.doc) {
        let unit = 50 / 10;
        return { width: `${unit * this.doc.cols}%` };
      } else {
        return null;
      }
    },
    computedTheme() {
      return this.doc.theme === "light" ? "grey lighten-4" : "grey darken-3";
    },
  },

  watch: {
    doc: {
      deep: true,
      handler() {
        this.revision++;
      },
    },
  },
  mounted() {},

  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("on save");
      this.dialogMode = "save";
      this.dialog = true;
    },
    onLoadedRef(refs) {
      if (refs) {
        this.refs = refs[0];
      }
    },
    onLoadedEx(items) {
      // this.initIso();
      if (items) {
        this.mergeArrays(items[0].doc);
        if (items.length) {
          // this.doc.controls = items[0].doc.controls;
          // this.doc.note = items[0].doc.note;
          this.editKey++;
        }
      }
    },
    onModifyEx(items) {
      if (items) {
        this.exercises = [...items];
      }
    },
    onSavedNext() {
      this.nextStep();
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
    updateItems(val) {
      this.doc.allItems.length = 0;
      this.doc.allItems.push(...val);
    },
    mergeArrays(arr) {
      console.log("arr", arr);
      if (this.doc) {
        Object.entries(arr).forEach(([outerKey, value]) => {
          if (typeof value === "object") {
            Object.entries(value).forEach(([key, value]) => {
              this.doc[outerKey][key] = value;
            });
          }
          if (typeof value === "string") {
            this.doc[outerKey] = value;
          }
          if (typeof value === "boolean") {
            this.doc[outerKey] = value;
          }
        });
      } else {
        this.doc = arr;
      }
    },
  },
};
</script>

<style lang="scss">
.auto {
  display: flex;
  flex-wrap: nowrap;
  .col-auto {
    width: auto;
    flex: 1;
  }
}
</style>
